import { memo, useMemo } from 'react';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

import { useCursorPositionFix } from 'src/lib/hooks/useCursorPositionFix';

const CustomTextField = ({
  inputProps,
  disallowLogRocket,
  dataTestId,
  value,
  onChange,
  ...restProps
}) => {
  const localInputProps = useMemo(
    () => ({
      ...inputProps,
      'data-testid': dataTestId,
      'data-private': disallowLogRocket ? '' : null,
    }),
    [inputProps, disallowLogRocket, dataTestId]
  );

  const { value: fixedValue, onChange: fixedOnChange } = useCursorPositionFix(value, onChange);

  return (
    <TextField
      inputProps={localInputProps}
      value={fixedValue}
      onChange={fixedOnChange}
      {...restProps}
    />
  );
};

CustomTextField.propTypes = {
  inputProps: PropTypes.shape(),
  disallowLogRocket: PropTypes.bool,
  dataTestId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};
CustomTextField.defaultProps = {
  inputProps: null,
  disallowLogRocket: false,
  dataTestId: null,
  value: '',
  onChange: null,
};

export default memo(CustomTextField);
